module.exports = __webpack_public_path__ + "img/vx_duomai.e543fecd.png";